import { render, staticRenderFns } from "./FileMessage.vue?vue&type=template&id=273b0051&scoped=true"
import script from "./FileMessage.vue?vue&type=script&lang=js"
export * from "./FileMessage.vue?vue&type=script&lang=js"
import style0 from "./FileMessage.vue?vue&type=style&index=0&id=273b0051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b0051",
  null
  
)

export default component.exports